<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eOexI6/tc-custom/9781460328828.jpg?1738298772754" alt="This image is the cover for the book Last Prince of Dahaar"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Last Prince of Dahaar
      </h1>
      <p class="bookDescription body article font2">
        <p>A vow to break?  <br/><br/>She's a bullet point on the list of things he's agreed to for duty. And as it is the only way to restore order in Dahaar and quash whispers that name him The Mad Prince, Ayaan Al Sharif will marry Zohra Naasar. <br/><br/>Zohra knows something of duty's destructionit's stolen her freedom before, and it won't happen again. She'll convince Ayaan not to marry herby refusing to sleep with him! Even if he does evoke a desire she's never felt before. <br/><br/>Ayaan may have agreed to her outrageous demand, but is this the one promise the last prince of Dahaar can't keep?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tara Pammi
      </h2>
      
      <p class="authorDescription body article">Tara Pammi can't remember a moment when she wasn't lost in a book, especially a romance which, as a teenager, was much more exciting than mathematics textbook. Years later Tara’s wild imagination and love for the written word revealed what she really wanted to do: write! She lives in Colorado with the most co-operative man on the planet and two daughters. Tara loves to hear from readers and can be reached at tara.pammi@gmail.com or her website www.tarapammi.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?68e82cb4